import type { CompositionV2DataQuery } from '@revelio/data-access';

import {
  type CompositionV3AnyGraphqlResponse,
  isCompositionV3FullMetrics,
} from '../composition/composition-v3/composition-v3-graphql-response';

type CompositionV2 = NonNullable<CompositionV2DataQuery['composition_v2']>;

export function adaptCompositionV3ForMarketConditions(
  payload: CompositionV3AnyGraphqlResponse | undefined | null,
  monthRefs: string[]
): CompositionV2 | undefined {
  if (!payload) {
    return undefined;
  }

  return {
    refs: { months: monthRefs },
    entities: (payload.entities ?? []).map((e) => {
      const m = isCompositionV3FullMetrics(e.metrics) ? e.metrics : undefined;
      return {
        metadata: {
          id: e.id,
          short_name: e.short_name,
          long_name: e.long_name,
        },
        metrics: {
          headcount: (e.metrics?.headcount ?? []).map((p) => ({
            id: p.id,
            value: p.val,
          })),
          salary: (m?.salary ?? []).map((p) => ({
            id: p.id,
            value: p.val,
          })),
        },
      };
    }),
  } as CompositionV2;
}
